import React, { useState, useRef } from "react";
import { Html, Scroll, Text, useVideoTexture } from "@react-three/drei";
import { animated, useSpring, config } from "@react-spring/web";
import { Box, Flex } from "@react-three/flex";
import { VideoComponent } from "./VideoComponent";

export default function Proyectos({ isMobile }) {
  const ProyectosComponent = () => {
    return (
      <Text
        font="/fonts/Ki-Light.otf"
        fontSize={isMobile ? 0.05 : 0.26}
        position={[isMobile ? 0 : -1, 0.7, 0]}
        rotation={[0, isMobile ? 0 : 0.3, 0]}
      >
        PROYECTOS
      </Text>
    );
  };

  const PrincipalesComponent = () => {
    return (
      <Text
        font="/fonts/Ki-Light.otf"
        fontSize={isMobile ? 0.05 : 0.26}
        position={[isMobile ? 0 : 1, isMobile ? -0.7: 0.7, 0]}
        rotation={[0, isMobile ? 0 : -0.3, 0]}
      >
        PRINCIPALES
      </Text>
    );
  };

  const VideosComponent = () => {
    const handleProjectSelection = (idx) => {
      console.log("idx", idx);
      // open a new tab with the project url
      if (idx == 1) {
        window.open("https://3d-flow-mintsite.vercel.app/", "_blank");
      }
      if (idx == 2) {
        window.open("https://artisocial.vercel.app/", "_blank");
      }
      if (idx == 3) {
        window.open("https://www.flowallets.com", "_blank");
      }
    };

    return (
      <Flex
        width="100%"
        justify="space-around"
        centerAnchor
        flexDirection={isMobile ? "column" : "row"}
        size={isMobile ? [0.7, 1, 1] : [3, 1, 1]}
      >
        <Box centerAnchor>
        <VideoComponent
            isMobile={isMobile}
            url="https://3d-flow-mintsite.vercel.app/"
            title="cyphers"
            idx={1}
            vid={"/cyphers.webm"}
            scale={0.7}
            rotation={[0, 0, isMobile ? 0 : 0.3, isMobile ? 0.9 : 0]}
          />
        </Box>
        <Box
          centerAnchor
          marginTop={isMobile ? 0.2 : 0}
          marginBottom={isMobile ? 0.2 : 0}
          marginLeft={isMobile ? 0 : 0.1}
          marginRight={isMobile ? 0 : 0.1}
        >
          <VideoComponent
            isMobile={isMobile}
            url="https://artisocial.vercel.app/"
            title="artisocial"
            idx={1}
            vid={
              "https://res.cloudinary.com/ddbgaessi/video/upload/v1668717424/artisocial_-_Made_with_Clipchamp_1668717146668_i14jvk.mp4"
            }
            scale={0.7}
            position={[0, 0, 0.2]}
          />
        </Box>
        <Box centerAnchor>
          <VideoComponent
            isMobile={isMobile}
            url="https://flowallets.com"
            title="flowallets"
            idx={1}
            vid={
              "https://res.cloudinary.com/ddbgaessi/video/upload/v1668720489/Untitled_video_-_Made_with_Clipchamp_2_trvoot.mp4"
            }
            scale={0.7}
            rotation={[0, isMobile ? 0 : -0.3, 0]}
          />
        </Box>
      </Flex>
    );
  };

  return (
    <>
      <ProyectosComponent />
      <VideosComponent />
      <PrincipalesComponent />
    </>
    //   {/* <PrincipalesComponent />
    //   < /> */}
    // // </Html>
  );
}
